export enum DiagnosticProviders {
    Mitchell = "mitchell",
    Jaltest = "jaltest"
}